import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("../views/accueil/indexView.vue"),
  },

  {
    path: "/career",
    name: "career",
    component: () => import("../views/career/indexView.vue"),
  },

  {
    path: "/contact",
    name: "contact",
    component: () => import("../views/contact/indexView.vue"),
  },

  {
    path: "/know",
    name: "know",
    component: () => import("../views/know/indexView.vue"),
  },

  {
    path: "/offers",
    name: "offers",
    component: () => import("../views/offers/indexView.vue"),
  },

  {
    path: "/send-cv",
    name: "send-cv",
    component: () => import("../views/send-cv/indexView.vue"),
  },

  {
    path: "/start-project",
    name: "start-project",
    component: () => import("../views/start-project/indexView.vue"),
  },

  {
    path: "/storytell",
    name: "storytell",
    component: () => import("../views/storytell/indexView.vue"),
  },
  {
    path: "/legal",
    name: "legal",
    component: () => import("../views/legal/indexView.vue"),
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // Toujours afficher la page depuis le haut
    return { top: 0, behavior: 'smooth' }
  }
});

export default router;
